import { Font } from "@/src/components";
import styles from "./index.module.scss";
import { useEffect, useRef } from "react";
import { OtherProduct, ShowcaseProduct, WordStyling } from "@/src/utils/types/landingpage";
import PointLine4 from "@/src/components/icons/PointLine4";
import ProductDetail from "../ProductDetail";

export default function LandingProducts({
  showcases,
  others,
  totalUsecase,
  listWordStyling,
}: {
  showcases: ShowcaseProduct[];
  others: OtherProduct[];
  totalUsecase: number;
  listWordStyling: WordStyling[];
}) {
  const titleRef = useRef(null);
  const otherRef = useRef(null);
  const otherLogoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
    };

    const callback: IntersectionObserverCallback = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target === otherLogoRef.current) {
            for (let index = 0; index < entry.target.children.length; index++) {
              const child = entry.target.children.item(index);
              child?.classList?.add(styles["visible"]);
            }
          } else {
            entry.target.classList.add(styles["visible"]);
          }
          
          observer.unobserve(entry.target)
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
  
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }
    if (otherRef.current) {
      observer.observe(otherRef.current);
    }
    if (otherLogoRef.current) {
      observer.observe(otherLogoRef.current);
    }
    // Clean up
    return () => {
      observer.disconnect();
    };
  }, [
    titleRef,
    otherRef,
    otherLogoRef,
  ]);

  return (
    <div className={styles["products-section"]}>
      <div className={styles["point-line"]}>
        <PointLine4 />
      </div>
      <div
        ref={titleRef}
        className={styles["main-service-title"]}
      >
        <div className={styles["header"]}>
          <Font variant="title-2-bold" color="black">
            Lebih dari&nbsp;
          </Font>
          <Font variant="title-2-bold" color="orange80">
            {`${totalUsecase} use cases `}
          </Font>
          <Font variant="title-2-bold" color="black">
            telah dikembangkan pada&nbsp;
          </Font>
          <Font variant="title-2-bold" color="blue80">
            {`${showcases?.length + others?.length} produk BRI`}
          </Font>
        </div>
      </div>
      <div className={styles["product-list-wrapper"]}>
        {showcases?.map((item) => (
          <ProductDetail
            key={item.nama_produk}
            showcase={item}
            listWordStyling={listWordStyling}
          />
        ))}
      </div>
      <div
        ref={otherRef}
        className={styles.others_wrapper}
      >
        <Font variant='title-4-bold' color='dark40' >
          {`dan ${others?.length} produk lainnya`}
        </Font>
        <div 
          ref={otherLogoRef}
          className={styles.logo_wrapper}
        >
          {others?.map(other => (
            <img
              key={other.nama_produk}
              className={styles.image_logo}
              src={`${process.env.NEXT_PUBLIC_IMAGES}/${other.logo_produk}`}
              alt={other.nama_produk}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
